// @flow
import type { Element } from 'react';

import React from 'react';
import { Col, Row } from 'reactstrap';
import { FieldArray } from 'redux-form';
import {
  OCCUPANCY,
  OCCUPANCY_BY_STORY,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import FieldVisibilityToggle from '#components/pages/Models/Model/sections/support/forms/FieldVisibilityToggle/index.js';
import { Field, Fieldset } from '#components/pages/Models/Model/support/form/index.js';
import renderOccupancyByStory from './renderOccupancyByStory/index.jsx';

type Props = {|
  afterToggleOn: Function,
  defineByStory: boolean,
  form: string,
|};

const OccupancyFieldset = ({
  afterToggleOn,
  defineByStory,
  form,
}: Props): Element<typeof Fieldset> => {
  const { fieldsByName } = modelTypesByForm[form];
  const supportDefineByStory = !!fieldsByName[OCCUPANCY_BY_STORY];
  return (
    <Fieldset>
      <legend>Occupancy</legend>
      <Row>
        {supportDefineByStory && (
          <Col>
            <FieldVisibilityToggle
              afterToggleOn={afterToggleOn}
              className="float-right define-occupancy-toggle"
              form={form}
              on={defineByStory}
              onFields={[OCCUPANCY_BY_STORY]}
              onText="Use simplified"
              offFields={[OCCUPANCY]}
              offText="Define by Story"
            />
          </Col>
        )}
      </Row>
      {defineByStory ? (
        <FieldArray
          form={form}
          name={OCCUPANCY_BY_STORY}
          component={renderOccupancyByStory}
          fieldsByName={fieldsByName}
        />
      ) : (
        <Row>
          <Col lg="5">
            <Field field={fieldsByName[OCCUPANCY]} />
          </Col>
        </Row>
      )}
    </Fieldset>
  );
};

export default OccupancyFieldset;
